import styled from 'styled-components';

export const ShowMore = styled.button`
  background: none;
  border: none;
  font-weight: 600;
  line-height: 1.43;
  color: ${({ theme }) => theme.primaryBackgroundColor}};
  height: 70px;
  width: 100%;
  cursor: pointer;
`;
